import React from "react";
import { useNavigate } from "react-router-dom";

import { LogoutConfirmModal } from "../../components/LogoutConfirmModal/LogoutConfirmModal";
import styles from "./Logout.module.scss";

export const Logout: React.FC = () => {
  const navigate = useNavigate();
  const [isLogoutModalOpen, setIsLogoutModalOpen] = React.useState(false);

  React.useEffect(() => {
    setIsLogoutModalOpen(true);
  }, []);

  const handleCancel = () => {
    setIsLogoutModalOpen(false);
    navigate("/profile/history");
  };

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Выход</h2>
      <p className={styles.description}>
        Вы уверены, что хотите выйти из учетной записи?
      </p>
      <LogoutConfirmModal
        isOpen={isLogoutModalOpen}
        setIsOpen={setIsLogoutModalOpen}
      />
    </div>
  );
};
